/*
 * @Author: Latte
 * @Date: 2022-01-12 14:20:12
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-12 14:25:53
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\aliyun.js
 */
import request from "@/utils/request";
import config from "@/utils/config";

/**
 * 获取OSS上传信息
 *
 * @param {*} params
 */
export function getOSSUploadInfo(params) {
	return request({
		url: config.API_MEDICAL + "/Api/V1/ALiYunCloud/TokenAndPath",
		method: "get",
		params,
	});
}
